/* hero-carousel.js — multi-slide hero carousel.
   Auto-rotate + dot navigation. Single slide = no-op.
   Vanilla, no globals. Degrades gracefully without JS (first slide visible). */

class HeroCarousel extends HTMLElement {
  connectedCallback() {
    this.slides = this.querySelectorAll('[data-hero-slide]');
    this.dots = this.querySelectorAll('[data-hero-dot]');
    this.viewport = this.querySelector('[data-hero-viewport]');

    if (!this.slides.length) return;
    if (this.slides.length === 1) return;

    this.currentIndex = 0;
    this.autoplay = this.getAttribute('data-autoplay') === 'true';
    this.delay = parseInt(this.getAttribute('data-autoplay-delay') || '5', 10) * 1000;
    this.timer = null;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.goTo = this.goTo.bind(this);
    this.next = this.next.bind(this);

    this.dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        this.goTo(parseInt(dot.getAttribute('data-slide-index'), 10));
      }.bind(this));
    }.bind(this));

    if (this.autoplay && !this.reduceMotion) {
      this.startAutoplay();
      this.viewport.addEventListener('mouseenter', this.stopAutoplay.bind(this));
      this.viewport.addEventListener('mouseleave', this.startAutoplay.bind(this));
    }

    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        this.stopAutoplay();
      } else if (this.autoplay && !this.reduceMotion) {
        this.startAutoplay();
      }
    }.bind(this));
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }

  startAutoplay() {
    this.stopAutoplay();
    this.timer = setInterval(this.next, this.delay);
  }

  stopAutoplay() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  next() {
    var nextIndex = (this.currentIndex + 1) % this.slides.length;
    this.goTo(nextIndex);
  }

  goTo(index) {
    if (index === this.currentIndex) return;
    this.currentIndex = index;

    this.slides.forEach(function(slide, i) {
      var active = i === index;
      slide.classList.toggle('hero__slide--active', active);
    });

    this.dots.forEach(function(dot, i) {
      var active = i === index;
      dot.classList.toggle('hero__dot--active', active);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }
}

if (!customElements.get('hero-carousel')) {
  customElements.define('hero-carousel', HeroCarousel);
}
